// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3tG19","active":"Navbar_active__Lsnmt","btn":"Navbar_btn__2wHe5","navbar-nav-svg":"Navbar_navbar-nav-svg__3ocu0"};